export const COHORT = 'cohort';
export const NOT_ENROLLED = 'not-enrolled';

export const WHITEBOARDS_ENTRYPOINT_EXPERIMENT = 'jsw_sprint_planning_whiteboards';

export const WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS = {
	CONTEXT_MENU: 'variant_contextual_menu',
	BACKLOG_BUTTON: 'variant_backlog_button',
	CONTROL: 'control',
} as const;

export type WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS =
	(typeof WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS)[keyof typeof WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS];
